import { useState, useCallback } from 'react';

type UseActivityFilterModalStateResponse = {
	activityFilterModalOpen: boolean;
	openActivityFilterModal: () => void;
	closeActivityFilterModal: () => void;
};

export const useActivityFilterModalState = (): UseActivityFilterModalStateResponse => {
	const [activityFilterModalOpen, setActivityFilterModalOpen] = useState(false);

	const openActivityFilterModal = useCallback(() => {
		setActivityFilterModalOpen(true);
	}, [setActivityFilterModalOpen]);

	const closeActivityFilterModal = useCallback(() => {
		setActivityFilterModalOpen(false);
	}, [setActivityFilterModalOpen]);

	return {
		activityFilterModalOpen,
		openActivityFilterModal,
		closeActivityFilterModal,
	};
};
